module.exports = __webpack_public_path__ + "img/HC3P_Carrousel_5.8a9d6a7a.jpg";